import { render, staticRenderFns } from "./lbbprs-table.vue?vue&type=template&id=4aa4dd52"
import script from "./lbbprs-table.vue?vue&type=script&lang=js"
export * from "./lbbprs-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports